<!-- im客户端 入口 -->
<template>
    <div>
        <div class="yuntucao-link" v-if="imCilientshow == false">
            <div class="logo-wrap" @click="feedbackModalShow">
                <div class="logo"></div>
                <div class="red-dot" v-if="showRedDot" :class="{ 'blink': isBlinking }"></div> <!-- 小红点 -->
            </div>
            <div class="tips-wrap fade-in">
                <div class="tips">
                    <span>{{ $t('imClient.chatWithUs') }}</span>
                </div>
            </div>
        </div>
        <div class="imClient-wrapper" v-if="imCilientshow == true">
            <div class="imClient-inner">
                <header class="imClient-header">
                                        <div class="name-wrapper position-v-mid">
                        <span v-if="chatInfoEn.chatState === 'connecting' || assignFail || kickFail || rateWord || retryCountShow || csUserIdShow">{{ $t('imClient.connecting') }}</span>
                        <span v-else-if="chatInfoEn.chatState === 'agent'">{{ $t('imClient.chattingWithAgent', { agentName: serverChatEn.serverChatName }) }}</span>
                    </div>
                    <div class="opr-wrapper position-v-mid">
                        <!-- <el-tooltip content="评分" placement="bottom" effect="light">
                            <i class="fa fa-star-half-full" @click="showRateDialog()"></i>
                        </el-tooltip> -->
                        <span @click="toggleImage" style="display: none;">
                            <img :src="currentImage" alt="sound">
                        </span>
                        <span style="font-size: 20px;">
                            <i class="el-icon-arrow-down" @click="closeChatDown()"></i>
                        </span>

                        <!-- <el-tooltip content="留言" placement="bottom" effect="light">
                        <i class="fa fa-envelope-o" @click="showLeaveDialog()"></i>
                    </el-tooltip> -->
                        <!-- <el-tooltip content="结束会话" placement="bottom" effect="light"> -->
                        <span style="font-size: 20px;">
                            <i class="el-icon-close" @click="closeChat()"></i>
                        </span>

                        <!-- </el-tooltip> -->
                    </div>
                </header>
                <main class="imClient-main">
                    <!-- 聊天框 -->
                    <div class="item imClientChat-wrapper">
                        <!-- 聊天记录 -->
                        <common-chat ref="common_chat" class="common_chat" @closeChatIm="closeChatIm"
                            @continueToConsult="continueToConsult" :assignFail="assignFail" :rateWord="rateWord" :dataIsRated="dataIsRated"
                            @sendRate="sendRate" :rateShow="rateShow" :chatInfoEn="chatInfoEn" :kickFail="kickFail" :retryCountShow="retryCountShow" :csUserIdShow="csUserIdShow"
                            :page="datas.pageNum" :historyDataList="historyDataList" :total="total"
                            @loadMore="loadMoreMessages" :oprRoleName="'client'" @sendMsg="sendMsg"
                            @chatCallback="chatCallback" :socketConnected="socketConnected"></common-chat>
                    </div>
                    <!-- 满意度dialog -->
                    <el-dialog :show-close="false" :visible.sync="rateDialogVisible" :modal-append-to-body='false'
                        :append-to-body="false" :center="true">
                        <im-rate ref="im_rate" @custom-event="submitEndDialog" :sendRateTwo="sendRateTwo" :dataItem="dataItem" :groupId="groupId"></im-rate>
                    </el-dialog>
                    <!-- 结束会话dialog -->
                    <el-dialog class="imClient-logoutDialog" :visible.sync="logoutDialogVisible"
                        :modal-append-to-body='false' :append-to-body="false" :center="true">
                        <p class="title" style="text-align: center;">{{ $t('imClient.endConversation') }}</p>
                        <div class="footer">
                            <el-button type="primary" size="mini" @click="logoutDialog_submit">{{ $t('imClient.endSession') }}</el-button>
                            <el-button size="mini" @click="logoutDialog_cancel">{{ $t('imClient.cancel') }}</el-button>
                        </div>
                    </el-dialog>
                </main>


            </div>
            <!-- 转接客服dialog -->
            <!-- <el-dialog title="请选择客服" :visible.sync="transferDialogVisible" :close-on-press-escape="false">
            <im-transfer ref="im_transfer" @submit="transferDialog_submit"></im-transfer>
        </el-dialog> -->

            <!-- 离线留言dialog -->
            <el-dialog :visible.sync="leaveDialogVisible" :close-on-press-escape="false">
                <im-leave ref="im_leave"></im-leave>
            </el-dialog>

        </div>
    </div>
</template>

<script >
import commonChat from '@/components/common/common_chat.vue';
import imRate from './imRate.vue';
import imLeave from './imLeave.vue';
// import imTransfer from './imTransfer.vue';
import { EventBus } from '@/common/event-bus.js';
import { historyList,assignCS } from '@/common/imCilent.js';
export default {
    components: {
        commonChat: commonChat,
        imRate: imRate,
        imLeave: imLeave,
        // imTransfer: imTransfer
    },
    data() {
        return {
            socket: null,
            chatInfoEn: {
                chatState: 'robot', // chat状态；robot 机器人、agent 客服
                inputContent: '', // 输入框内容
                msgList: [], // 消息列表
                state: 'on', // 连接状态;on ：在线；off：离线
                lastMsgShowTime: null,
                ackState: 'off', // 最后一个消息的显示时间
                renderMsgList: [], //消息队列的数据列表
                referenceContent: {} //引用的消息
            }, // 会话信息，包括聊天记录、状态
            clientChatEn: {
                clientChatId: '',
                clientChatName: '',
                avatarUrl: 'static/image/im_client_avatar.png'
            }, // 当前账号的信息
            serverChatEn: {
                serverChatName: '',
                avatarUrl: ''
            }, // 服务端chat信息
            robotEn: {
                robotName: '小旺',
                avatarUrl: 'static/image/im_robot_avatar.png'
            }, // 机器人信息
            // faqList: [
            //     { title: '今天周几', content: '今天周一' },
            //     { title: '今天周几', content: '今天周二' },
            //     { title: '今天周几', content: '今天周三' },
            //     { title: '今天周几', content: '今天周四' },
            //     { title: '今天周几', content: '今天周五' }
            // ],
            faqSelected: '-1',
            inputContent_setTimeout: null, // 输入文字时在输入结束才修改具体内容
            selectionRange: null, // 输入框选中的区域
            shortcutMsgList: [], // 聊天区域的快捷回复列表
            logoutDialogVisible: false, // 结束会话显示
            transferDialogVisible: false, // 转接人工dialog
            rateDialogVisible: false, // 评价dialog
            leaveDialogVisible: false, // 留言dialog
            isToggled: true, // 用于跟踪当前图片状态
            defaultImage: require('@/assets/sound.png'), // 默认图片路径
            toggledImage: require('@/assets/sound_active.png'), // 点击后切换的图片路径
            imCilientshow: false,
            numbers: 0,  //是否点击了收起
            globalUserId: '',
            groupId: '',
            maxRetry: 3,  // 最大重发次数
            retryInterval: 10000,  // 重发扫描的时间间隔（10 秒）
            timeout: 5000, // 重发超时时间（5 秒）
            total: 0, //历史消息总数
            historyDataList: [], //历史消息集合
            datas: {
                messageTo: null,
                globalUserId: null,
                pageNum: 1,
                pageSize: 20,
            },
            scrollDirection: null,  // 用于记录滚动方向，'up' 或 'down'
            lastScrollTop: 0,       // 上一次的滚动位置
            assignFail: false,
            kickFail: false,
            rateWord: false,
            rateShow: false,
            retryCountShow:false,
            csUserIdShow: false,
            loginMsg: {}, //登录的信息
            showRedDot: false, // 控制小红点的显示
            isBlinking: false,
            sendRateTwo: null, //是否自动回复评价消息 0：不回复 1：自动回复
            dataItem: {},
            dataIsRated: {},
            isSocketRegistered: false, // 标志
            pendingMsgList: [], // socket 未就绪时暂存的消息队列
            socketConnected: false // socket 是否已连接
        };
    },
    computed: {
        currentImage() {
            return this.isToggled ? this.toggledImage : this.defaultImage;
        },
    },
    watch: {

    },
    mounted() {
        // 监听父页面发送的消息
        window.addEventListener('message', this.handleMessage);
        // EventBus.$on('messageFromJS', (datas) =>{
        //     // 根据消息类型执行相应的操作
        //     console.log('名称： ' + JSON.stringify(datas));
        //     // if (event.data.type === 'greeting') {
        //     // this.message = event.data.content; // 显示父页面的消息内容
        //     this.loginMsg = datas.data;
        //     // this.loginMsg = {
        //     //     tmschat_user_id: '02',   //用户ID
        //     //     tmschat_user_name: 'haha2', //用户昵称
        //     //     tmschat_agent_id: '', //采购ID
        //     //     tmschat_agent_name: '', //采购名称
        //     //     tmschat_system_name: '线上系统', //系统名称
        //     //     tmschat_system_domain: 'test.51kongtie.net', // 系统域名
        //     //     // tmschat_message_content: '咨询订单：111',
        //     //     tmschat_show_dialog:false,
        //     //     tmschat_message_url:'http://test.51kongtie.net/train!orderdetail.action?payType=0&extType=0&intelligentTrip=0&trainorder.id=366736287'
        //     // }
        //     // alert('Message from parent: ' + event.data.content);
        //     if (!this.isSocketRegistered) {
        //         this.regSocket();
        //         this.isSocketRegistered = true; // 设置标志变量为已调用
        //     }
        //             if(this.loginMsg.tmschat_message_content){
        //                 if (this.loginMsg.tmschat_show_dialog == false ) {
        //                     //console.log(this.loginMsg.tmschat_message_content)
        //                     this.getOrderId();
        //                     // setTimeout(() => {

        //                     // }, 5000);

        //                 } else if (this.loginMsg.tmschat_show_dialog == true) {
        //                     this.imCilientshow = true;
        //                     // 发送消息给父页面，告诉它调整 iframe 大小
        //                     const message = {
        //                                 type: 'resizeIframe',
        //                                 width: 400,
        //                                 height: 500
        //                             };
        //                     window.parent.postMessage(message, '*'); // 向父页面发送消息
        //                     this.getOrderId();
        //                     // this.regSocket();
        //                 }
        //         }



        //     // }
        // })
        // this.regClientChatEn();

        // setTimeout(() => {
        //     const childEl = this.$refs.common_chat.$refs;  // 直接访问 DOM 元素

        //     const container = childEl.common_chat_main;
        //     //console.log(container);  // 查看是否找到了元素

        //     if (container) {
        //         container.addEventListener('scroll', this.handleScroll);
        //     } else {
        //         //console.log('.common_chat-main element not found');
        //     }
        // }, 3000);

        // 定时扫描消息列表，每 10 秒检查一次

        // this.timer = setInterval(() => {
        //     //console.log('开始扫描消息列表');
        //     this.scanMessageList();  // 扫描消息列表
        // }, this.retryInterval);
    },
    methods: {
        handleMessage(event) {
            // 根据消息类型执行相应的操作
            console.log('名称： ' + JSON.stringify(event.data));
            // if (event.data.type === 'greeting') {
            // this.message = event.data.content; // 显示父页面的消息内容
            this.loginMsg = event.data;

            // 同步语言设置
            if (event.data.tmschat_locale) {
                this.$i18n.locale = event.data.tmschat_locale;
                localStorage.setItem('language', event.data.tmschat_locale);
            }
            // this.loginMsg = {
            //     tmschat_user_id: '02',   //用户ID
            //     tmschat_user_name: 'haha2', //用户昵称
            //     tmschat_agent_id: '', //采购ID
            //     tmschat_agent_name: '', //采购名称
            //     tmschat_system_name: '线上系统', //系统名称
            //     tmschat_system_domain: 'test.51kongtie.net', // 系统域名
            //     // tmschat_message_content: '咨询订单：111',
            //     tmschat_show_dialog:false,
            //     tmschat_message_url:'http://test.51kongtie.net/train!orderdetail.action?payType=0&extType=0&intelligentTrip=0&trainorder.id=366736287'
            // }
            // alert('Message from parent: ' + event.data.content);
            if (!this.isSocketRegistered) {
                this.regSocket();
                this.isSocketRegistered = true; // 设置标志变量为已调用
            } else if (this.socketConnected && this.chatInfoEn.chatState === 'connecting') {
                // socket 已连接但还没登录成功，loginMsg 刚收到，立即重试登录
                console.warn('loginMsg received after socket connected, retrying getLogin...');
                this.getLogin();
            }
                    if(this.loginMsg.tmschat_message_content){
                        if (this.loginMsg.tmschat_show_dialog == false ) {
                            //console.log(this.loginMsg.tmschat_message_content)
                            this.getOrderId();
                            // setTimeout(() => {

                            // }, 5000);

                        } else if (this.loginMsg.tmschat_show_dialog == true) {
                            this.imCilientshow = true;
                            // 发送消息给父页面，告诉它调整 iframe 大小
                            const message = {
                                        type: 'resizeIframe',
                                        width: 400,
                                        height: 500
                                    };
                            window.parent.postMessage(message, '*'); // 向父页面发送消息
                            this.getOrderId();
                            // this.regSocket();
                        }
                }



            // }
        },
        getOrderId: function () {
            let msg = {
                requestId: this.generateRequestId(),
                timestamp: Date.now(),
                createTime: new Date(),
                ackState: false, // ack状态 是否收到ack改变状态
                retryCount: 0,
                isSuccess: true, // 标记消息是否发送成功
                role: 'client',
                content: this.loginMsg.tmschat_message_content,
                contentType: 0,
                // messageExpand:{
                //     order_url:this.loginMsg.tmschat_message_url
                // }

            }
            //console.log(this.loginMsg.tmschat_message_content);
            this.$data.socket.emit('send', {
                requestId: msg.requestId,
                timestamp: Date.now(),
                version: '1.0',
                globalUserId: this.globalUserId,
                from: this.globalUserId,
                groupId: this.groupId,
                contentType: msg.contentType,
                content: msg.content,
                // messageExpand:{
                //     order_url:this.loginMsg.tmschat_message_url
                // }
            }, (res, val) => {
                //console.log(res);
                if (!res) {
                    // //console.log(`消息 ${msg.requestId} 超时，重新发送`);
                    // 重发逻辑，调用sendMsg函数重新发送
                    // 启动消息处理的队列控制，确保发送完成后再处理下一条
                    this.processNextMessage();
                    return;
                }
                // this.handleSendResponse(res, msg);
            });
            // 2.添加到消息集合里
            var self = this;
            this.addChatMsg(msg, function () {
                self.goEnd();
            });
            // 更新消息列表
            this.$set(this.chatInfoEn, 'msgList', [...this.chatInfoEn.msgList]);
            //console.log(this.chatInfoEn)
        },
        // 订单号获取并发送
        // getOrderId: function () {
        //     //console.log(this.loginMsg.tmschat_message_content)

        // },
        /**
         * 注册账号信息
         */
        regClientChatEn: function () {
            this.$data.clientChatEn.clientChatId = Number.parseInt(Date.now() + Math.random());
            // 名称格式：姓+6位数字
            var userName = '';
            switch (this.$data.clientChatEn.clientChatId % 5) {
                case 0:
                    userName = '张';
                    break;
                case 1:
                    userName = '李';
                    break;
                case 2:
                    userName = '王';
                    break;
                case 3:
                    userName = '赵';
                    break;
                case 4:
                    userName = '孙';
                    break;
            }
            var tmpId = this.$data.clientChatEn.clientChatId.toString();
            userName += tmpId.substr(tmpId.length - 6, 6);
            this.$data.clientChatEn.clientChatName = userName;

            // 模拟消息
            // this.addChatMsg({
            //     role: 'robot',
            //     avatarUrl: this.$data.robotEn.avatarUrl,
            //     contentType: 'transformServer'
            // });
        },

        login(socket, callback) {
            const timeoutDuration = 30000; // 超时时间（3秒）
            let retryCount = 0;
            const MAX_RETRY_ATTEMPTS = 3;
            let isLoggedIn = false;

            // 登录请求逻辑
            const sendLoginRequest = () => {
                if (isLoggedIn) {
                    // 如果已经登录成功，则停止重试
                    return;
                }
                if (isLoggedIn || retryCount >= MAX_RETRY_ATTEMPTS) {
                    // 如果已经登录成功或达到最大重试次数，则停止重试
                    this.retryCountShow = true;
                    return;
                }
                // if (this.imCilientshow == false) {
                //     return;
                // }
                let isTimeout = false;

                // 设置超时计时器
                const timeout = setTimeout(() => {
                    isTimeout = true;
                    console.log('Request timed out');
                    retryLogin();
                }, timeoutDuration);
                // 获取url中的userId参数
                // const url = new URL(window.location.href);
                // let userId = url.searchParams.get('userId');
                // //console.log(userId);
                // let globalUserId;
                // if (userId != null) {
                //     globalUserId = `test.51kongtie.net_userId_${userId}`
                //     userId = userId;
                // } else {
                //     globalUserId = 'test.51kongtie.net_userId_1234567'
                //     userId = '1234567';
                // }
                // //console.log(globalUserId);
                // //console.log(userId);
                //console.log(this.loginMsg.tmschat_system_domain + '_' + this.loginMsg.tmschat_user_id);
                //console.log(this.loginMsg.tmschat_user_name);
                // 发送login请求并处理响应
                socket.emit('login', {
                    requestId: this.generateRequestId(), // 请求id
                    timestamp: Date.now(),
                    version: "1.0",
                    globalUserId: this.loginMsg.tmschat_system_domain + '_' + this.loginMsg.tmschat_user_id,
                    userName: this.loginMsg.tmschat_user_name,
                    userId: this.loginMsg.tmschat_user_id,
                    userType: 0,
                    agentId: this.loginMsg.tmschat_agent_id,
                    loginSystemName: this.loginMsg.tmschat_system_name,
                    loginSystemDomain: this.loginMsg.tmschat_system_domain
                }, (res, val) => {
                    clearTimeout(timeout); // 清除超时计时器

                    if (isTimeout) {
                        console.log('Login attempt timed out');
                        return;
                    }

                    console.log('Login response:', res, val);
                    if (res && res.code === 20000) {
                        // 登录成功，标记为已登录
                        isLoggedIn = true;
                        this.retryCountShow = false;
                        if(res.csUserId==null){
                            if(this.kickFail==true){
                                this.kickFail = false;
                                this.continueToConsult();
                            }
                            this.csUserIdShow = true;
                        }else{
                            this.kickFail = false;
                            this.csUserIdShow = false;
                        }
                        callback(true, res); // 登录成功回调
                    } else {
                        // 登录失败，增加重试次数并尝试重新登录
                        console.log('Login failed, retrying...');
                        retryLogin();
                    }
                });
            };

            // 重试登录的逻辑
            const retryLogin = () => {
                retryCount++;
                sendLoginRequest();
            };

            // 发起登录请求
            sendLoginRequest();
        },
        /**
         * 注册socket
         * @param {String} serverChatId 服务端chatId
         */
        regSocket: function (serverChatId) {
            this.numbers = 0
            this.rateWord = false;
            // this.$data.socket = require('socket.io-client')('ws://192.168.2.120:17000/ws');
            const io = require('socket.io-client');
            //console.log("ws domain", process.env.VUE_APP_WS_DOMAIN);
            this.$data.socket = io(process.env.VUE_APP_WS_DOMAIN, {
                transports: ['websocket']
            });
            // this.$data.socket = io('ws://192.168.2.120:17000')
            this.$data.socket.on('connect', () => {
                console.log('socket connected');
                this.socketConnected = true;
                this.getLogin();

                //  客户端上线
                // // 定时请求login并检查是否超时
                // const timeoutDuration = 3000; // 超时时间（3秒）
                // let isLoggedIn = false;  // 用于控制是否已经登录成功
                // const sendLoginRequest = () => {
                //     // 如果已经登录成功，则不再发送请求
                //     if (isLoggedIn) return;

                //     let isTimeout = false;

                //     // 设置超时计时器
                //     const timeout = setTimeout(() => {
                //         isTimeout = true;
                //         //console.log('Request timed out');
                //         sendLoginRequest();
                //     }, timeoutDuration);

                //     // 发送login请求并处理响应
                //     this.$data.socket.emit('login', {
                //         requestId: this.generateRequestId(), // 请求id
                //         timestamp: Date.now(),
                //         version: "1.0",
                //         globalUserId: "test.51kongtie.net_userId_1234567",
                //         userName: "无双",
                //         userId: "userId_1234567",
                //         userType: 0,
                //         agentId: "agentId_123",
                //         loginSystemName: "线上后台",
                //         loginSystemDomain: "test.51kongtie.net"
                //     }, (res, val) => {
                //         clearTimeout(timeout); // 清除超时计时器
                //         //console.log('Login', this.generateRequestId())
                //         if (!isTimeout) {
                //             // 如果没有超时，处理服务器响应
                //             //console.log('Login response:', res, val);
                //             if (res.code === 20000) {
                //                 // 登录成功，标记为已登录
                //                 isLoggedIn = true;
                //                 //console.log('Login successful!');
                //                 this.globalUserId = res.globalUserId;
                //                 this.groupId = res.groupId;
                //             } else {
                //                 // 登录失败，保持递归继续尝试
                //                 //console.log('Login failed, retrying...');
                //             }
                //         }

                //         // 如果没有成功登录且未超时，继续请求
                //         if (!isLoggedIn && !isTimeout) {
                //             sendLoginRequest();
                //         }
                //     });
                // };

                // // 启动请求
                // sendLoginRequest();

                // // 服务端链接
                // this.$data.socket.on('SERVER_CONNECTED', (data) => {
                //     // 1)获取客服消息
                //     this.$data.serverChatEn = data.serverChatEn;

                //     // 2)添加消息
                //     this.addChatMsg({
                //         role: 'sys',
                //         contentType: 'text',
                //         content: '客服 ' + data.serverChatEn.serverChatName + ' 为你服务'
                //     });
                // });



                // // 离开
                // window.addEventListener('beforeunload', () => {
                //     this.closeChat();
                // });


            });
            this.$data.socket.on('disconnect', (err) => {
                console.error('WebSocket disconnect server:', err);
                this.socketConnected = false;
            });
            this.$data.socket.on('error', (err) => {
                console.error('WebSocket error:', err);
                this.socketConnected = false;
            });
            this.$data.socket.on('connect_error', (err) => {
                console.error('Connection error:', err);
                this.socketConnected = false;
            });
            // 接受服务端信息
            this.$data.socket.on('receive', (data, ack) => {
                // console.log('receive', data);
                if (data.referenceContent) {
                    data.referenceContent = JSON.parse(data.referenceContent);
                }
                if(data.contentExpand){
                    data.contentExpand= JSON.parse(data.contentExpand);
                }
                if(this.imCilientshow==false){
                        this.showRedDot= true;// 控制小红点的显示
                        this.isBlinking= true;
                    }

                // data.msg.avatarUrl = this.$data.serverChatEn.avatarUrl;
                this.addChatMsg(data, () => {
                    if(this.imCilientshow==true){
                        this.$refs.common_chat.goEnd();
                    }


                });
                if(data.contentType!==2){
                    this.imCilientshow = true;
                    const message = {
                        type: 'resizeIframe',
                        width: 400,
                        height: 500
                    };
                    window.parent.postMessage(message, '*'); // 向父页面发送消息
                }
                // 构建ACK数据
                const ackData = {
                    from: data.from,
                    groupId: data.groupId,
                    content: data.content,
                    contentType: data.contentType,
                    requestId: this.generateRequestId(), // 请求ID
                    timestamp: Date.now(),     // 当前时间戳
                    version: "1.0",            // 固定版本号
                    globalUserId: this.globalUserId, // 全局用户ID
                    code: 20000,               // 固定成功code码
                    message: "ack",            // 确认消息
                    messageId: data.messageId // 服务端的messageId
                };
                ack(ackData)


                this.notify(data.content)


                // 发送ACK回服务器
                // this.sendAck(data);
            });
            // 分配客服失败
            this.$data.socket.on('assign_fail', (data, ack) => {
                console.log('assign_fail event received:', data);
                if (data) {
                    this.assignFail = true
                    const ackData = {
                        from: data.from,
                        groupId: data.groupId,
                        requestId: this.generateRequestId(), // 请求ID
                        timestamp: Date.now(),     // 当前时间戳
                        version: "1.0",            // 固定版本号
                        globalUserId: this.globalUserId, // 全局用户ID
                        code: 20000,               // 固定成功code码
                        message: "ack",            // 确认消息
                        // messageId: data.messageId // 服务端的messageId
                    };
                    ack(ackData)
                } else {
                    this.assignFail = false
                }
            })
            // 会话结束
            this.$data.socket.on('session_end', (data, ack) => {
                //console.log('session_end', data);
                if (data) {
                    this.rateWord = true
                    const ackData = {
                        from: data.from,
                        groupId: data.groupId,
                        requestId: this.generateRequestId(), // 请求ID
                        timestamp: Date.now(),     // 当前时间戳
                        version: "1.0",            // 固定版本号
                        globalUserId: this.globalUserId, // 全局用户ID
                        code: 20000,               // 固定成功code码
                        message: "ack",            // 确认消息
                        // messageId: data.messageId // 服务端的messageId
                    };
                    ack(ackData)
                } else {
                    this.rateWord = false
                }
            })
            // 踢人下线
            this.$data.socket.on('kick', (data, ack) => {
                //console.log('kick', data);
                if (data) {
                    this.kickFail = true;
                    const ackData = {
                        from: data.from,
                        groupId: data.groupId,
                        requestId: this.generateRequestId(), // 请求ID
                        timestamp: Date.now(),     // 当前时间戳
                        version: "1.0",            // 固定版本号
                        globalUserId: this.globalUserId, // 全局用户ID
                        code: 20000,               // 固定成功code码
                        message: "ack",            // 确认消息
                        // messageId: data.messageId // 服务端的messageId
                    };
                    ack(ackData)
                } else {
                    this.kickFail = false;
                }
            })
            // 客服主动会话用户消息
            this.$data.socket.on('active_session', (data, ack) => {
                console.log('active_session', data);
                if (data) {
                    this.rateWord = false
                    const ackData = {
                        from: data.from,
                        groupId: data.groupId,
                        requestId: this.generateRequestId(), // 请求ID
                        timestamp: Date.now(),     // 当前时间戳
                        version: "1.0",            // 固定版本号
                        globalUserId: this.globalUserId, // 全局用户ID
                        code: 20000,               // 固定成功code码
                        message: "ack",            // 确认消息
                        // messageId: data.messageId // 服务端的messageId
                    };
                    ack(ackData)
                } else {
                    this.rateWord = true;
                }
            })

        },
        notify(content) {
          if (!window.Notification) {
            console.log("浏览器不支持Notification");
            return;
          }
          if (Notification.permission === "granted") {
            this.generateNotification("您有新消息", content);
          } else if (Notification.permission === "default") {
            Notification.requestPermission().then(permission => {
              if (permission === "granted") {
                this.generateNotification("您有新消息", content);
              } else {
                console.log("user click " + permission);
              }
            });
          }
        },
        generateNotification(title,body) {
            var options = {
                dir: "auto",
                lang: "",
                tag: "tag1",
                renotify: true,
                requireInteraction: true,
                body: body
            }
            var notify = new Notification(title, options);
            notify.onshow = function () {
                // 30s关闭
                setTimeout(function () {
                    notify.close();
                }, 30000);

            }
            notify.onclick = function() {
                window.focus();
            };
        },
        getLogin() {
            // 调用登录函数并传递相应的回调
            this.login(this.$data.socket, (success, res) => {
                if (success) {
                    // 登录成功后的逻辑
                    console.log('Login successful! 完整响应:', res);
                    console.log('>>> csUserId =', res.csUserId, '| groupId =', res.groupId);
                    this.globalUserId = res.globalUserId;
                    this.groupId = res.groupId;
                    // ✅ 重置所有可能导致"连接中"状态的标志
                    this.assignFail = false;
                    this.kickFail = false;
                    this.rateWord = false;
                    this.retryCountShow = false;
                    this.rateShow = false;
                    if (res.csUserId == null) {
                        this.csUserIdShow = true;
                    } else {
                        this.csUserIdShow = false;
                    }
                    console.log('[STATE] getLogin success, setting chatState = agent');
                    this.chatInfoEn = {
                        chatState: 'agent', // chat状态；robot 机器人、agent 客服
                        inputContent: '', // 输入框内容
                        msgList: [], // 消息列表
                        state: 'on', // 连接状态;on ：在线；off：离线
                        lastMsgShowTime: null,
                        ackState: 'off', // 最后一个消息的显示时间
                        renderMsgList: [], //消息队列的数据列表
                    } // 会话信息，包括聊天
                    // 发送暂存的消息
                    this.flushPendingMsgs();
                    //console.log(this.loginMsg.tmschat_show_dialog)
                    if(this.loginMsg.tmschat_message_content){
                        if(this.loginMsg.tmschat_show_dialog==true){
                            setTimeout(() => {
                                this.getOrderId();
                            }, 1000);

                        }
                    }

                    let datas = {
                        messageTo: this.groupId,
                        globalUserId: this.globalUserId,
                        pageNum: this.datas.pageNum,
                        pageSize: this.datas.pageSize,
                    }
                    // 获取历史消息
                    historyList(datas).then((res) => {
                        this.$data.total = res.total
                        let row = res.rows;
                        this.$data.historyDataList = this.convertMessages(row).reverse()
                        if(this.imCilientshow==true){
                            this.$refs.common_chat.goEnd();
                        }
                        //console.log(this.$data.historyDataList)
                    })


                    // if(this.loginMsg.tmschat_message_content ){
                    //     this.getOrderId();
                    // }
                } else {
                    // 登录失败后的逻辑
                    //console.log('Failed to log in after 3 attempts');
                    // 处理失败，提示用户等
                }
            });
        },

        // 转换函数
        convertMessages(messages) {
            return messages.map(message => {
                const role = message.senderType === 1 ? 'server' : 'client'; // 判断角色
                return {
                    contentType: message.contentType,  // 内容类型
                    content: message.messageContent,   // 消息内容
                    role: role,                        // 角色（客服或用户）
                    createTime: new Date(message.createTime).toISOString(),  // 格式化时间
                    timestamp: message.sendTime,              // 时间戳（毫秒）
                    requestId: message.messageRequestId,  // 请求 ID
                    ackState: false,                   // 默认状态为 false
                    retryCount: 0,                     // 默认重试次数为 0
                    isSuccess: true,                   // 默认消息成功
                    referenceContent: JSON.parse(message.referenceContent),
                    fromName: message.nickName,
                    messageExpand: JSON.parse(message.messageExpand),
                    isRated: false, // 新增字段，表示是否已经评价
                };
            });
        },
        // 加载更多历史消息
        loadMoreMessages(callback) {
            //   if (this.isLoading || this.historyDataList.length >= this.total) {
            //     return; // 防止重复加载
            //   }
            if (!callback) {
                callback = (success) => { }
            }
            this.datas.pageNum += 1; // 增加页码
            this.isLoading = true; // 开始加载

            // 请求数据
            const datas = {
                messageTo: this.groupId,
                globalUserId: this.globalUserId,
                pageNum: this.datas.pageNum,
                pageSize: this.datas.pageSize,
            };

            historyList(datas).then((res) => {
                this.isLoading = false; // 停止加载状态
                this.total = res.total; // 更新总数

                if (res.rows && res.rows.length > 0) {
                    const newMessages = this.convertMessages(res.rows).reverse(); // 转换消息格式
                    this.historyDataList = [...newMessages, ...this.historyDataList]; // 追加新消息
                    callback(true);
                } else {
                    // 如果没有更多数据，显示“没有更多了”
                    this.isLoading = false;
                    callback(false);
                }
            }).catch(() => {
                this.isLoading = false; // 出错时也停止加载状态
                callback(false);
            });
        },

        // // 发送ACK的函数
        // sendAck(data) {
        //     // 构建ACK数据
        //     const ackData = {
        //         requestId: this.generateRequestId(), // 请求ID
        //         timestamp: Date.now(),     // 当前时间戳
        //         version: "1.0",            // 固定版本号
        //         globalUserId: this.globalUserId, // 全局用户ID
        //         code: 20000,               // 固定成功code码
        //         message: "ack",            // 确认消息
        //         messageId: data.messageId // 服务端的messageId
        //     };

        //     // 发送ACK回服务器
        //     this.$data.socket.emit('ack', ackData);
        // },
        // 生成一个随机的 requestId（UUID 或随机字符串）
        generateRequestId() {
            // 使用 UUID v4 生成一个唯一的 requestId
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        /**
         * 结束会话
         */
        closeChat: function () {
            // if (this.$data.chatInfoEn.chatState == 'agent') {
            //     this.$data.socket.emit('CLIENT_OFF', {
            //         clientChatEn: this.$data.clientChatEn,
            //         serverChatId: this.$data.serverChatEn.serverChatId
            //     });
            //     this.$data.socket.close();
            //     this.$data.chatInfoEn.state = 'off';
            // }
            // this.$data.logoutDialogVisible = true;
            // this.rateShow !== true &&
            if ( this.rateWord !== true&&this.rateShow !== true) {
                this.rateDialogVisible = true;
            } else {
                //this.$data.socket.close();
                this.imCilientshow = false;
                // this.chatInfoEn = {
                //     chatState: 'robot', // chat状态；robot 机器人、agent 客服
                //     inputContent: '', // 输入框内容
                //     msgList: [], // 消息列表
                //     state: 'on', // 连接状态;on ：在线；off：离线
                //     lastMsgShowTime: null,
                //     ackState: 'off', // 最后一个消息的显示时间
                //     renderMsgList: [], //消息队列的数据列表
                // } // 会话信息，包括聊天
                const message = {
                    type: 'resizeIframe',
                    width: 200,
                    height: 100
                };
                window.parent.postMessage(message, '*'); // 向父页面发送消息
            }


            // this.chatInfoEn = {
            //     chatState: 'robot', // chat状态；robot 机器人、agent 客服
            //     inputContent: '', // 输入框内容
            //     msgList: [], // 消息列表
            //     state: 'on', // 连接状态;on ：在线；off：离线
            //     lastMsgShowTime: null,
            //     ackState: 'off', // 最后一个消息的显示时间
            //     renderMsgList: [], //消息队列的数据列表
            // } // 会话信息，包括聊天
            // const message = {
            //     type: 'resizeIframe',
            //     width: 200,
            //     height: 100
            // };
            // window.parent.postMessage(message, '*'); // 向父页面发送消息

        },

        /**
         * 添加chat对象的msg
         * @param {Object} msg 消息对象；eg：{role:'sys',content:'含有新的消息'}
         * @param {String} msg.role 消息所有者身份；eg：'sys'系统消息；
         * @param {String} msg.contentType 消息类型；0:文本(默认)；2:图片
         * @param {String} msg.content 消息内容
         * @param {Function} successCallback 添加消息后的回调
         */
        addChatMsg: function (msg, successCallback) {
            //console.log(msg)
            // 1.设定默认值

            var msgList = this.$data.chatInfoEn.msgList ? this.$data.chatInfoEn.msgList : [];

            // 2.插入消息
            // 1)插入日期
            // 实际场景中，在消息上方是否显示时间是由后台传递给前台的消息中附加上的，可参考 微信Web版
            // 此处进行手动设置，5分钟之内的消息，只显示一次消息
            msg.createTime = new Date(msg.createTime);
            // if (this.$data.chatInfoEn.lastMsgShowTime == null || msg.createTime.getTime() - this.$data.chatInfoEn.lastMsgShowTime.getTime() > 1000 * 60 * 5) {
            //     msgList.push({
            //         role: 'sys',
            //         contentType: 0,
            //         content: this.$ak.Utils.getDateTimeStr(msg.createTime, 'Y-m-d H:i:s')
            //     });
            //     this.$data.chatInfoEn.lastMsgShowTime = msg.createTime;
            // }

            // 2)插入消息
            msgList.push(msg);

            // 3.设置chat对象相关属性
            // this.$data.chatInfoEn.msgList = msgList;
            // this.$data.chatInfoEn.renderMsgList = msgList;
            // 更新渲染队列
            this.$set(this.chatInfoEn, 'msgList', [...msgList]);  // 保证消息不会被移除
            this.$set(this.chatInfoEn, 'renderMsgList', [...msgList]);
            //console.log(msgList)
            // 4.回调
            successCallback && successCallback();
        },

        /**
         * 发送消息
         * @param {Object} rs 回调对象
         */
        sendMsg: function (rs) {
            var msg = rs.msg;
            msg.role = msg.role == undefined ? 'sys' : msg.role;
            msg.contentType = msg.contentType == undefined ? 0 : msg.contentType;
            msg.createTime = msg.createTime == undefined ? new Date() : msg.createTime;
            msg.timestamp = Date.now();
            msg.requestId = this.generateRequestId();
            msg.ackState = false;  // ack状态 是否收到ack改变状态
            msg.retryCount = 0;
            msg.content = msg.contentType == 4 ? msg.fileUrl : msg.content;
            msg.isSuccess = true; // 标记消息是否发送成功
            console.log('[STATE at sendMsg] chatState =', this.$data.chatInfoEn.chatState, '| socketConnected =', this.socketConnected);
            console.log(msg);
            //console.log(msg.requestId);
            msg.role = 'client';
            let referenceContent = {
                messageId: msg.referenceContent.messageId,
                content: msg.referenceContent.content,
                contentType:  msg.referenceContent.contentType
            }
            console.log("chatInfoEn",this.$data.chatInfoEn)
            // 机器人发送接口或客服接口
            if (this.$data.chatInfoEn.chatState == 'robot') {
                // 机器人处理逻辑
            } else if (this.$data.chatInfoEn.chatState == 'agent') {
                // 客服接口
                if (!this.$data.socket) {
                    console.warn('Socket 未建立，消息暂存');
                    this.pendingMsgList.push(msg);
                    return;
                }
                console.log('>>> 正在通过 socket 发送消息:', msg.content);
                this.$data.socket.emit('send', {
                    requestId: msg.requestId,
                    timestamp: msg.timestamp,
                    version: '1.0',
                    globalUserId: this.globalUserId,
                    from: this.globalUserId,
                    groupId: this.groupId,
                    contentType: msg.contentType,
                    content: msg.content,
                    referenceContent: JSON.stringify(referenceContent)
                }, (res, val) => {
                    //console.log(res);
                    if (!res) {
                        //console.log(`消息 ${msg.requestId} 超时，重新发送`);
                        // 重发逻辑，调用sendMsg函数重新发送
                        // 启动消息处理的队列控制，确保发送完成后再处理下一条
                        this.processNextMessage();
                        return;
                    }
                    // this.handleSendResponse(res, msg);
                });
            } else {
                // chatState === 'connecting' 时发不到服务器，但消息会显示在本地 UI
                console.warn('>>> chatState 仍是 connecting，消息只显示在本地，未发送到服务器！当前状态:', this.$data.chatInfoEn.chatState, '| csUserIdShow:', this.csUserIdShow, '| assignFail:', this.assignFail);
            }

            // 2.添加到消息集合里
            var self = this;
            this.addChatMsg(msg, function () {
                self.goEnd();
            });
            // 更新消息列表
            this.$set(this.chatInfoEn, 'msgList', [...this.chatInfoEn.msgList]);


        },

        // 发送暂存的消息队列
        flushPendingMsgs() {
            if (this.pendingMsgList.length === 0) return;
            console.log(`开始发送 ${this.pendingMsgList.length} 条暂存消息`);
            while (this.pendingMsgList.length > 0) {
                const msg = this.pendingMsgList.shift();
                this.doSendMsg(msg);
            }
        },

        // 实际发送单条消息（不含 addChatMsg）
        doSendMsg(msg) {
            this.$data.socket.emit('send', {
                requestId: msg.requestId,
                timestamp: msg.timestamp,
                version: '1.0',
                globalUserId: this.globalUserId,
                from: this.globalUserId,
                groupId: this.groupId,
                contentType: msg.contentType,
                content: msg.content,
                referenceContent: msg.referenceContent ? JSON.stringify(msg.referenceContent) : undefined
            }, (res) => {
                if (!res) {
                    this.processNextMessage();
                }
            });
        },

        // 处理消息队列，确保顺序发送消息
        async processNextMessage() {
            let messageQueue = this.chatInfoEn.renderMsgList.filter(msg => msg.role === 'client'); // 渲染消息队列
            let renderQueue = this.chatInfoEn.msgList || []; // 已发送的消息队列


            //console.log("消息队列:", messageQueue);
            //console.log("渲染队列:", renderQueue);

            while (messageQueue.length > 0) {
                let currentMessage = messageQueue[0]; // 获取队列中的第一条消息
                //console.log('处理消息:', currentMessage);

                if (!currentMessage) {
                    //console.log("当前消息无效，跳过");
                    messageQueue.shift();
                    continue;
                }

                // 发送并重试当前消息
                await this.sendWithRetry(currentMessage);

                // 更新渲染数据状态
                let index = renderQueue.findIndex(msg => msg.requestId === currentMessage.requestId);
                if (index !== -1) {
                    renderQueue[index].isSuccess = currentMessage.isSuccess;
                }

                // 使用非破坏性更新，确保渲染队列数据更新
                this.$set(this.chatInfoEn, 'renderMsgList', [...renderQueue]);

                // 将已处理的消息从渲染队列移除
                messageQueue.shift();

                //console.log("更新后的渲染队列:", renderQueue);

                // 每处理一条消息后，使用 setTimeout 延迟执行下一条，避免栈溢出
                await new Promise(resolve => setTimeout(resolve, 0));
            }
            //console.log("消息队列处理完毕");
        },

        // 发送消息并处理重试逻辑
        async sendWithRetry(msg) {
            let self = this;
            let maxRetries = 3;
            let retryInterval = 3000; // 重试间隔 3秒

            // 发送并重试当前消息
            const sendMessageWithRetry = async () => {
                if (msg.retryCount >= maxRetries) {
                    // 如果重试次数达到最大值，标记为失败
                    msg.isSuccess = false;
                    //console.log(`消息 ${msg.requestId} 重试3次仍未成功，标记为未发送成功`);
                    this.getLogin();
                    return; // 停止当前消息的递归处理
                }

                console.log(`发送消息 ${msg.content}，当前重试次数: ${msg.retryCount}`);
                try {
                    // 使用 Promise 封装 socket.emit 异步操作
                    const res = await new Promise((resolve, reject) => {
                        this.$data.socket.emit('send', {
                            requestId: msg.requestId,
                            timestamp: msg.timestamp,
                            version: '1.0',
                            globalUserId: this.globalUserId,
                            from: this.globalUserId,
                            groupId: this.groupId,
                            contentType: 0,
                            content: msg.content
                        }, (res, val) => {
                            if (res) {
                                resolve(res); // 发送成功
                            } else {
                                reject(new Error("消息发送失败")); // 发送失败
                            }
                        });
                    });

                    if (res) {
                        // 如果发送成功，标记消息为已成功
                        msg.isSuccess = true;
                        //console.log(`消息 ${msg.requestId} 发送成功`);
                    }
                } catch (error) {
                    // 捕获发送失败的错误并打印
                    msg.retryCount += 1; // 增加重试次数
                    //console.log(`消息 ${msg.requestId} 重试次数: ${msg.retryCount}`);

                    // 延迟重试
                    await new Promise(resolve => setTimeout(resolve, retryInterval));
                    await sendMessageWithRetry(); // 延迟后重新发送
                }
            };

            // 开始发送并重试
            await sendMessageWithRetry();
        },




        /**
         * 显示转接客服Dialog
         */
        transferDialog_show: function () {
            this.$data.transferDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.im_transfer.init();
            });
        },

        /**
         * 转接客服dialog_提交
         */
        // transferDialog_submit: function(rs) {
        //     this.$data.transferDialogVisible = false;
        //     this.$data.chatInfoEn.chatState = 'agent';
        //     this.regSocket(rs.serverChatId);
        //     //console.log(rs.serverChatId);
        // },

        /**
         * 注销dialog_提交
         */
        logoutDialog_submit: function () {
            this.$data.logoutDialogVisible = false;
            this.addChatMsg({
                role: 'sys',
                content: this.$t('imClient.sessionEnded')
            });
        },

        /**
         * 注销dialog_取消
         */
        logoutDialog_cancel: function () {
            this.$data.logoutDialogVisible = false;
        },

        /**
         * 聊天记录滚动到底部
         */
        goEnd: function () {
            this.$refs.common_chat.goEnd();
        },

        /**
         * chat回调
         */
        chatCallback: function (rs) {
            if (rs.eventType == 'transformServer') {
                this.transferDialog_show();
            }
        },
        /**
         * 显示评分dialog
         */
        showRateDialog: function () {
            this.$data.rateDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.im_rate.init();
            });
        },
        submitEndDialog(data) {
            //console.log(data);
            if(data.item&&data.item.messageExpand){
                if (data.num == 1) {
                    this.dataIsRated = data.item;
                    //console.log(this.dataIsRated);
                } else if (data.num == 2) {
                    this.closeChatIm();
                }

            }else{
                if (data.num == 1) {
                    this.rateShow = true;
                    this.rateWord = true;
                    this.closeChatIm();
                } else if (data.num == 2) {
                    this.closeChatIm();
                }
            }

            this.$data.rateDialogVisible = false;
        },
        /**
         * 显示留言dialog
         */
        showLeaveDialog: function () {
            this.$data.leaveDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.im_leave.init();
            });
        },
        toggleImage() {
            this.isToggled = !this.isToggled; // 切换图片状态
        },
        feedbackModalShow() {
            console.log('[STATE] feedbackModalShow called, setting chatState = connecting');
            this.imCilientshow = true;
            // ✅ 无论是否已连接，都要通知父页面调整 iframe 尺寸
            window.parent.postMessage({ type: 'resizeIframe', width: 400, height: 500 }, '*');
            // ✅ 如果已经连接成功，不要重置 chatState
            if (this.chatInfoEn.chatState === 'agent') {
                console.log('[STATE] already agent, skip resetting chatState');
                return;
            }
            this.chatInfoEn.chatState = 'connecting';
            // ✅ 只有在真正需要重连时才设为 false，避免已连接的 socket 被错误置 false
            if (!this.isSocketRegistered) {
                this.socketConnected = false;
                this.regSocket();
            } else if (this.$data.socket && !this.$data.socket.connected) {
                // socket 断开了，重新连接
                this.socketConnected = false;
                this.$data.socket.connect();
            }
            this.showRedDot = false;
            this.isBlinking = false;
            // loginMsg 为空时主动向父页面请求用户数据
            if (!this.loginMsg.tmschat_user_id) {
                console.warn('loginMsg is empty, requesting from parent...');
                window.parent.postMessage({ type: 'requestLoginInfo' }, '*');
            }
        },
        closeChatDown() {
            this.imCilientshow = false;
            this.showRedDot = false; // 隐藏小红点
            this.isBlinking = false;
            this.numbers = 1;
            const message = {
                type: 'resizeIframe',
                width: 200,
                height: 100
            };
            window.parent.postMessage(message, '*'); // 向父页面发送消息
        },
        // 继续咨询
        continueToConsult() {
            if((this.csUserIdShow==false&&this.retryCountShow==true)||this.kickFail){
                this.getLogin();
            }else{
                assignCS({globalUserId:this.loginMsg.tmschat_system_domain + '_' + this.loginMsg.tmschat_user_id,loginSystemDomain:this.loginMsg.tmschat_system_domain}).then(res=>{
                    if(res.code==200&&res.data.csUserId){
                        this.rateWord = false;
                        this.csUserIdShow=false;
                        this.assignFail=false;
                        this.kickFail=false;
                        this.retryCountShow=false;
                    }
                })
            }


        },
        // 关闭
        closeChatIm() {
            //this.$data.socket.close();
            this.imCilientshow = false;
            // this.chatInfoEn = {
            //     chatState: 'robot', // chat状态；robot 机器人、agent 客服
            //     inputContent: '', // 输入框内容
            //     msgList: [], // 消息列表
            //     state: 'on', // 连接状态;on ：在线；off：离线
            //     lastMsgShowTime: null,
            //     ackState: 'off', // 最后一个消息的显示时间
            //     renderMsgList: [], //消息队列的数据列表
            // } // 会话信息，包括聊天
            const message = {
                type: 'resizeIframe',
                width: 200,
                height: 100
            };
            window.parent.postMessage(message, '*'); // 向父页面发送消息
        },
        sendRate(data) {
            this.rateDialogVisible = true;
            this.sendRateTwo = data.num
            this.dataItem= data.item
        }
    },

    // mounted() {
    //     this.regClientChatEn();
    // }
};
</script>

<style lang="less">
@import '../../common/css/base.less';

.imClient-wrapper {
    #common-wrapper();
}

.imClient-inner {
    width: 355px;
    height: 500px;
    margin: 10px auto 0px;
    overflow: hidden;
    box-shadow: 0 1px 5px 2px #ccc;
    position: fixed;
    right: 18px;
    bottom: 0;
    border-radius: 10px;

    .imClient-header {
        position: relative;
        height: 50px;
        box-sizing: border-box;
        background: #2295FF;
        font-size: 13px;
        color: #ffffff;

        .name-wrapper {
            margin-left: 20px;
        }

        .logo {
            height: 45px;
            width: auto;
        }

        .opr-wrapper {
            right: 20px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;

            span {
                margin-left: 10px;
                display: block;
            }

            .fa {
                margin-left: 10px;
            }
        }
    }

    .imClient-main {
        max-width: 100%;
        height: 450px;
        position: relative;

        &>.item {
            float: left;
            height: 100%;
            border-top-width: 0px;
            border-right-width: 0px;
            box-sizing: border-box;

            &:last-child {
                border-right-width: 1px;
            }
        }

        &>.imClientChat-wrapper {
            width: 355px;
            border-right: 1px solid #ccc;
        }

        &>.imClientInfo-wrapper {
            width: 300px;
        }
    }
}

// 信息区域
.imClientInfo-wrapper {
    width: 100%;
    height: 100%;
    background: #ffffff;

    .imClientInfo-notice-wrapper,
    .imClientInfo-faq-wrapper {
        .imClientInfo-item-header {
            font-weight: bolder;
            font-size: 16px;
            color: #1072b5;
            padding: 10px 15px 0;
        }
    }

    .imClientInfo-notice-wrapper {
        .imClientInfo-notice-main {
            padding: 0 15px;

            &>.link {
                margin: 10px 0;
                font-size: 12px;
                color: #000000;
            }
        }
    }

    .imClientInfo-faq-wrapper {
        height: 380px;
        border-top: 1px solid #ccc;

        .imClientInfo-faq-main {
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;

            .el-collapse {
                border: 0px;

                .el-collapse-item__header {
                    position: relative;
                    padding: 0px 15px;
                    font-size: 12px;
                    background: transparent;
                    color: #000000;

                    &.is-active {
                        color: #f7455d;
                    }

                    .el-collapse-item__arrow {
                        position: absolute;
                        left: 267px;
                    }
                }

                .el-collapse-item__wrap {
                    background: transparent;

                    .el-collapse-item__content {
                        font-size: 12px;
                        color: #959699;
                        padding: 0px 15px 10px;
                    }
                }
            }
        }
    }
}

// element-UI
.el-dialog {
    width: 500px;
    background: #ffffff;
    color: #000000;
}

.el-dialog__wrapper {
    position: absolute !important;
}

.v-modal {
    position: absolute !important;
}

.el-dialog {
    margin-top: 6vh !important;
    // box-sizing: border-box;
    padding: 10px 20px;
    width: 315px !important;
    margin: 0 20px;
}

.el-dialog__header {
    display: none;
}

.imClient-logoutDialog {
    .el-dialog {
        margin-top: 6vh !important;
        // box-sizing: border-box;
        padding: 10px 20px;
        width: 240px !important;
        margin: 0 auto;
        border: 1px solid #2295FF;
        border-top: 3px solid #2295FF;
    }

    .el-dialog__header {
        display: none;
    }

    .title {
        margin-top: 10px;
    }

    .footer {
        margin: 30px 0 10px 0;
        display: flex;
        justify-content: space-between;

        .el-button--mini,
        .el-button--mini.is-round {
            padding: 10px 0;
            width: 86px;
            border-radius: 2px;
        }
    }

}

.yuntucao-link {
    position: fixed;
    bottom: 45px;
    right: 30px;
    z-index: 1;
    height: 53px;
    background: #fff;
    border-radius: 20px;

    .logo-wrap {
        cursor: pointer;
        opacity: .9;
        padding: 15px 10px 10px;
        border-radius: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    }

}

.yuntucao-link .logo-wrap:hover {
    background: #2295FF;

    .logo {
        background: url('../../assets/message_active.png') no-repeat 0 center;
    }

}

.yuntucao-link {
    &:hover {
        .tips-wrap {
            position: relative;
            display: block !important;
        }
    }
}

.yuntucao-link .tips-wrap {
    position: relative;
    display: none;
    right: 12px;
}

.yuntucao-link .tips {
    background: #4e4e4e;
    border-radius: 4px;
    position: absolute;
    left: -98px;
    top: -44px;
}

.yuntucao-link .tips span {
    line-height: 32px;
    color: #fff;
    padding: 0 15px;
}

.logo {
    width: 32px;
    height: 28px;
    background: url('../../assets/message.png') no-repeat 0 center;
}

.fade-in {
    animation-timing-function: ease;
    -webkit-animation-timing-function: ease;
    animation: fadein .3s;
}

.yuntucao-link .tips::after {
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #4e4e4e;
    position: absolute;
    right: -6px;
    top: 10px;
}
.red-dot {
    position: absolute;
    top: 0;
    right: 0;
    width: 8px;
    height: 8px;
    background-color: red;
    border-radius: 50%;
}
@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.blink {
  animation: blink 1s step-start infinite;
}
</style>
